<div id="posicion_avance"></div>
<p>
    <strong>Latitud:</strong> {{ avance.latitud }} <strong>Longitud:</strong>
    {{ avance.longitud }}
</p>
